import { Grid } from '@material-ui/core'
import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import PaidLeaveMap from './paidLeaveMap'
import { GridWrapper } from '../../theme/Global'
import { hasPermission } from '../../account/selectors'
import PaidLeaveSummaryLinks from './paidLeaveSummaryLinks'
import RenewalDateWidget from '../../common/components/RenewalDateWidget'
import EmploymentLawNewsWidget from '../../common/components/EmploymentLawNewsWidget'
import { useAuth } from '../../auth/useAuth'
import AccountContact from '../../common/components/AccountContact/AccountContact'

const PaidLeaveDashboardRenderer = ({
  companyId,
  blogPosts
}) => {
  const { company } = useAuth()

  return (
    <GridWrapper>
      <Grid
        container
        spacing={40}
        direction="row"
        justify="center"
        alignItems="stretch"
      >
        <Grid item xs={10} md={8}>
          <Grid item xs={12}>
            <PaidLeaveMap {...{ companyId }} />
          </Grid>
          <Grid item xs={12}>
            <EmploymentLawNewsWidget blogPosts={blogPosts} />
          </Grid>
        </Grid>
        <Grid item xs={10} md={4}>
          <Grid item xs>
            <PaidLeaveSummaryLinks />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <AccountContact type="minWagePaidLeave" cardBg />
          </Grid>
          <Grid
            item
            xs
            style={{ margin: '2.5rem auto' }}
          >
            <RenewalDateWidget renewDate={company && company.paidLeave && company.paidLeave.renewDate ? company.paidLeave.renewDate : ''} />
          </Grid>
        </Grid>
      </Grid>
    </GridWrapper>
  )
}

const mapStateToProps = (state) => ({
  hasPaidLeave: hasPermission(state)('hasPaidLeave'),
  companyId: state.account.company._id,
  blogPosts: state.compliance.blogPosts.slice(0, 4)
})

PaidLeaveDashboardRenderer.propTypes = { hasPaidLeave: PropTypes.bool.isRequired }

const MinWageDashboardComponent = compose(connect(mapStateToProps))(PaidLeaveDashboardRenderer)

export default MinWageDashboardComponent
